export default "__VITE_ASSET__B62vv2aF__"